import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row, Col } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import Edit from '../../utils/edit';
import Head from '../../utils/head';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
const FormItem = Form.Item;

let getPartnerUrl = Urls.PartnerUrl.list;
let modify = Urls.PartnerUrl.modify;
let find = Urls.PartnerUrl.selectById;
let deleteUrl = Urls.PartnerUrl.delete;

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10,
            },
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }
    componentWillMount() {
        this.getList(getPartnerUrl + paramsEncode(this.state.serach));
    }

    async getList(url) {
        try {
            let response = await request(url);
            this.setState(Object.assign(this.state, response)); //total,list
        } catch (e) {
            alert(e.message);
        }
    }

    async confirm(record) {
        try {
            let response = await request(deleteUrl, 'delete', record);
            message.success('删除成功');
            this.handleRefresh(); //删除完成重新刷新网页
        } catch (e) {
            console.log(e);
            message.error('删除失败');
        }
    }

    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getPartnerUrl + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 }); //page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async url => {
            try {
                let response = await request(url);
                this.state.list = response.list;
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(getPartnerUrl + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getPartnerUrl + paramsEncode(this.state.serach));
    }

    render() {
        let metadata = [
            {
                type: 'Input',
                placeholder: '合作商名称',
                addonBefore: '合作商名称',
                initialValue: 'utf-8',
                field: 'name',
            },
        ];
        let addMetas = [
            {
                type: 'Input',
                placeholder: '合作商',
                isRequired: true,
                label: '合作商',
                field: 'name',
            },
            {
                type: 'Select',
                placeholder: '执行节点',
                isRequired: true,
                label: '执行节点',
                initialValue:'SERVER_NODE',
                field: 'belongNode',
                options: ['SERVER_NODE', 'PROXY_NODE']
            },
            {
                type: 'Select',
                placeholder: '定向限制',
                label: '定向限制',
                initialValue:'0',
                field: 'orientation',
                options: ['关闭|0', '打开|1']
            },
            {
                type: 'Select',
                placeholder: '代理范围',
                label: '代理范围',
                initialValue:'国内',
                field: 'proxyScope',
                options: ['国内', '全球']
            },
            {
                type: 'Select',
                label: '代理类型',
                placeholder: '代理类型',
                field: 'type',
                initialValue: 'http',
                options: ['http', 'socks']
            },
            {
                type: 'Input',
                placeholder: '备注',
                label: '备注',
                field: 'remark',
            },{
                type: 'Input',
                placeholder: '字符集',
                label: '字符集',
                initialValue: 'utf-8',
                field: 'charset',
            },{
                type: 'Select',
                label: '作用',
                placeholder: '用途',
                field: 'usedFor',
                initialValue: 'all',
                options: ['all', 'click', 'ev','appoint']
            },{
                type: 'Input',
                placeholder: '间隔',
                isRequired: true,
                label: '间隔',
                initialValue: '1000',
                field: 'interval',
            },{
                type: 'Input',
                placeholder: '类',
                isRequired: true,
                label: '类',
                field: 'className',
            },{
                type: 'Input',
                placeholder: '利用次数',
                isRequired: true,
                label: '利用次数',
                field: 'reusetimes',
            },{
                type: 'Input',
                placeholder: '自动分配每日最大量',
                isRequired: false,
                label: '自动分配每日最大量',
                field: 'totalNum',
            },{
                type: 'Input',
                placeholder: 'Url',
                isRequired: true,
                label: 'Url',
                field: 'url',
            }
        ];
        const columns = [
            {
                title: '名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '利用次数',
                dataIndex: 'reusetimes',
                key: 'reusetimes',
            },
            {
                title: '用途',
                dataIndex: 'usedFor',
                key: 'usedFor',
            },
            {
                title: '代理类型',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: '机器数量',
                dataIndex: 'num',
                key: 'num',
            },
            {
                title:'执行节点',
                dataIndex: 'belongNode',
                key: 'belongNode',
            },
            {
                title:'定向限制',
                dataIndex: 'orientation',
                key: 'orientation',
            },
            {
                title:'代理范围',
                dataIndex: 'proxyScope',
                key: 'proxyScope',
            },
            {
                title:'自动分配每日最大量',
                dataIndex: 'totalNum',
                key: 'totalNum',
            },
            {
                title: '操作',
                key: 'action',
                render: record => (
                    <span>
                        <Edit
                            metadata={addMetas}
                            url={modify}
                            find={find + '' + record._id}
                            handleRefresh={this.handleRefresh}
                        />
                        <span className="ant-divider" />
                        <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                            <a href="#">删除</a>
                        </Popconfirm>
                    </span>
                ),
            },
        ];
        return (
            <div>
                <h2>合作商列表</h2>
                <Row className="searchRow">
                    <Head
                        serachMeta={metadata}
                        addMeta={addMetas}
                        addUrl={modify}
                        handleRefresh={this.handleRefresh}
                        handleSerach={this.serach.bind(this)}
                    />
                </Row>
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className="ant-table-pagination"
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sider/partner.js